import React from "react";
import daburlogo from "./../../assets/icons/daburlogo.jpg"

const HeaderLogo = () => {
  return (
    <div className="md:ml-12 md:mr-12 ml-6 mr-6">
      <div className="pt-6 pb-12 mx-auto px-0 py-8">
        <div className="flex items-center justify-start">
          <img src={daburlogo} className="w-[150px]" alt="DaburLekha Logo" />
        </div>
      </div>
    </div>
  );
};

export default HeaderLogo;
